module.exports = __webpack_public_path__ + "img/chevron_easter23.05ba952d.svg";